import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { STATUS_MODEL } from '../../../../../enums/statusEnum';
import { useDispatch, useSelector } from 'react-redux';
import { GetPaymentEvidence } from '../../../../../reduxToolkit/Traffic/TrafficApi';
import { URL } from '../../../../../Apis/Constants';
import { toast } from 'react-toastify';
import { getFileIcon, getFileNameWithoutExtension } from '../../../../../Helpers/fileType';
import { IconFileEmpty } from '../../../../../components/buttons/IconButtons';
import { formatBytes } from '../../../../../Apis/functions';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const PaymentConfirmationModalApp = ({ onHide }) => {
    const { t } = useTranslation();
    let dispatch = useDispatch();

    const {finesTrafficDetails: trafficData} = useSelector((state) => state?.TrafficSlice);
    const {getPaymentEvidence: evidenceList} = useSelector((state) => state?.TrafficSlice);

    const [dataFile, setDataFile] = useState(null);

    /**
     * Function to retrieve payment evidences.
     */
    useEffect(() => {
        if (STATUS_MODEL.PAID === parseInt(trafficData?.statusId)) {
            dispatch(GetPaymentEvidence(trafficData?.finePaymentId)).then(({ payload: { data: { data } } }) => {
                buildDataFile(data[0]?.id, data[0]?.fileUploadDto)
            });
        }
    }, [trafficData]);

    /**
     * Function to download payment evidence.
     */
    const handleDownloadFiles = () => {
        const path = evidenceList[0]?.fileUploadDto?.filePath;
        if (path) {
            window.open(URL + path, '_blank');
        } else {
            toast.warning(t("no_evidence_registered"));
        }
        onHide();
    }

    /**
     * Function that constructs the object received for viewing the payment evidence file.
     * @param id
     * @param file
     */
    const buildDataFile = (id, file) => {
        const fileName = file?.userFileNames?.[0];
        setDataFile(
            {
                id: id || null,
                icon: fileName ? getFileIcon(fileName) : IconFileEmpty,
                fileValue: fileName || null,
                title: fileName ? getFileNameWithoutExtension(fileName) : t('not_yet'),
                size: file?.size ? formatBytes(file?.size) : null
            }
        )
    }

    return {
        t,
        dataFile,
        trafficData,
        handleDownloadFiles
    }

}

export default PaymentConfirmationModalApp
